export default {
  valueType: 'switch',
  FormItemProps: {
    label: '开关',
    valuePropName: "checked",
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    defaultChecked: false,
    checkedChildren: "开启",
    unCheckedChildren: "关闭",
    style: {}
  },
}
